import {RootState} from '../store';
import {createSelector} from '@reduxjs/toolkit';
import {GeneralStore} from "./initialState";
import {pageKeys, Pages} from "../../pages/pages";
import {isStaticPageSlug} from "../../services/url/staticPages";

export const generalStore = (state: RootState) => state.general;

export const getPage = createSelector([generalStore], (generalStore: GeneralStore) => {
    if (!pageKeys.includes(generalStore.page as Pages)) return pageKeys[0];
    if (isStaticPageSlug(generalStore.page)) return generalStore.page as Pages;
    switch (generalStore.page as Pages) {
        case 'results':
            return 'results';
        case 'card': {
            if (!generalStore.cardId) return 'home';
            return 'card';
        }
        case 'map':
            return 'map';
        default:
            return 'home'
    }
});

export const getModal = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.modal;
});

export const getCardId = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.cardId;
});
export const getSearchQuery = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.searchQuery;
});
export const getShowSidebar = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.showSidebar;
});
export const isAccessibilityActive = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.accessibilityActive;
})
export const isLoading = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.loading;
});

export const getIsLandingPage = createSelector([generalStore], (generalStore: GeneralStore) => {
    const firstUrl = generalStore.firstVisitedUrl;
    const currentUrl = window.location.href;
    return firstUrl === currentUrl;
})

export const getSelectedFeatureId = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.selectedFeatureId;
});

export const getOldURL = createSelector([generalStore], (generalStore: GeneralStore) => {
    return generalStore.oldURL;
});
